import { tokenId } from './getAccessToken';

/** Clears any legacy JS-readable auth cookie from older clients. */
export function deleteAccessToken() {
  document.cookie = `${tokenId}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}
